<template>
  <div>
    <div class="btn_box" v-if="showSelectBtn">
      <el-button type="primary" @click="add">商品选择</el-button>
    </div>
    <el-table
      ref="list"
      border
      :data="tableData"
      style="width: 100%"
      @row-click="rowClick"
      show-summary
      :summary-method="getSummaries"
    >
      <el-table-column type="index" label="序号" width="50" align="center"></el-table-column>
      <el-table-column prop="BarCode" label="条码">
        <template slot-scope="{ row }">
          <span>{{ row.BarCode }}</span>
        </template>
      </el-table-column>
      <el-table-column label="商品名称" min-width="150px" prop="GoodsName">
        <template slot-scope="{ row }">
          <account-select
            v-model="row.GoodsName"
            :source="DAccount"
            @select="onSelect($event, row)"
            v-if="!readonly"
            :pageSize="pageParams.pageSize"
            :pageIndex="pageParams.pageIndex"
            :listTotal="listTotal"
            @currentPage="currentPage($event, row)"
            @click.native="resetFun"
            @inputText="inputText($event, row)"
            :pageType="true"
          />
          <span v-else>{{ row.GoodsName }}</span>
        </template>
      </el-table-column>
      <el-table-column label="供应商" min-width="240px" prop="SupplierName">
        <template  slot-scope="{ row }">
          <supplier v-if="!readonly"  @restaurants="setSupplier($event, row)" :state="row.SupplierName"/>
           <span v-else>{{ row.SupplierName }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="Model" label="规格型号" />
      <el-table-column prop="Quantity" label="数量" width="90px">
        <template slot-scope="{ row }">
           <el-input
            v-model="row.Quantity"
            type="number"
            @input="changeNum(row)"
            @blur="onBlur(row,'changeNum')"
            @focus="onFocus(row,'changeNum')"
            v-if="!readonly"
          ></el-input>
          <span v-else>{{ row.Quantity }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="UnitId" label="单位">
        <template slot-scope="{ row }">
          <el-select
            v-if="row.Units && row.Units.length"
            v-model="row.UnitId"
            :placeholder="readonly?'':'请选择'"
            :disabled="true"
          >
            <el-option
              v-for="(item,index) in row.Units"
              :key="index"
              :label="item.UnitName"
              :value="item.UnitId"
            ></el-option>
          </el-select>
          <span v-else>{{row.UnitName}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="Offer" label="报价">
        <template slot-scope="{ row }">
          <el-input
            v-model="row.Offer"
            type="number"
            @input="rateChange(row)"
            @blur="onBlur(row,'Offer')"
            @focus="onFocus(row,'Offer')"
            v-if="!readonly"
          ></el-input>
          <span v-else>{{ $commonJs.getThousandNum(row.Offer) }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="Discount" label="折扣%">
        <template slot-scope="{ row }">
          <el-input
            v-model="row.Discount"
            type="number"
            @input="disChange(row)"
            @blur="onBlur(row,'Discount')"
            @focus="onFocus(row,'Discount')"
            v-if="!readonly"
          ></el-input>
          <span v-else>{{ row.Discount }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="NoTaxPrice" label="无税单价" v-if="disposeTax == 1">
        <template slot-scope="{ row }">{{$commonJs.getThousandNum(row.NoTaxPrice)}}</template>
      </el-table-column>
      <el-table-column prop="TaxRate" label="税率/%" v-if="disposeTax == 1">
        <template slot-scope="{ row }">
          <el-input
            v-model="row.TaxRate"
            type="number"
            @input="rateChange(row)"
            @blur="onBlur(row,'TaxRate')"
            @focus="onFocus(row,'TaxRate')"
            v-if="!readonly"
          ></el-input>
          <span v-else>{{ row.TaxRate }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="Price" label="单价">
        <template slot-scope="{ row }">{{$commonJs.getThousandNum(row.Price)}}</template>
      </el-table-column>
      <!-- <template slot-scope="{ row }">
          <el-input v-model="row.Price" type="number" @input="rateChange(row)" v-if="!readonly"></el-input>
          <span v-else>{{row.Price}}</span>
      </template>-->
      <!-- </el-table-column> -->
      <el-table-column prop="TaxAmount" label="税额" v-if="disposeTax == 1">
        <template slot-scope="{ row }">{{$commonJs.getThousandNum(row.TaxAmount)}}</template>
      </el-table-column>
      <el-table-column prop="Amount" label="含税金额">
        <template slot-scope="{ row }">{{$commonJs.getThousandNum(row.Amount)}}</template>
      </el-table-column>
      <el-table-column prop="NoTaxAmount" label="不含税金额" width="90px">
        <template slot-scope="{ row }">{{$commonJs.getThousandNum(row.NoTaxAmount)}}</template>
      </el-table-column>
      <!-- <el-table-column prop="num" label="包装数量" /> -->
      <el-table-column label="操作" align="center" width="130px" v-if="!readonly" fixed="right">
        <template slot-scope="scope">
          <el-link
            icon="el-icon-copy-document"
            style="margin-right:10px;"
            @click.stop="copy(scope.row, scope.$index)"
            :underline="false"
          >复制</el-link>
          <el-link
            icon="el-icon-delete"
            @click.stop="del(scope.row, scope.$index)"
            :underline="false"
          >删除</el-link>
        </template>
      </el-table-column>
    </el-table>
    <el-divider></el-divider> 
    <goods-dialog ref="goodsDialog" inDialog selectable  @select="selectGood" />
    <price-dialog ref="dialog" inDialog @save="save"></price-dialog>
  </div>
</template>
<script>
import dialog from "@/mixins/dialog";
import accountSelect from "@/components/sales/business/select";
import supplier from "@/components/common/supplier/supplier";
import goodsDialog from "@/components/basicinfo/goods/archives/listDialog";
import priceDialog from './priceDialog';

export default {
   mixins: [dialog],
  props: {
    info: {},
    readonly: {
      type: Boolean,
      default: false,
    },
    disposeTax: {
      type: [String, Number],
      default: "",
    },
    showSelectBtn: {
      type: Boolean,
      default: true
    }
  },
  components: {
    accountSelect,
    supplier,
    goodsDialog,
    priceDialog,
  },
  data() {
    return {
      listTotal: 0,
      pageParams: {
        pageSize: 7, //分页大小
        pageIndex: 1,
      },

      tableData: [],
      tableDel: [],
      multi: require("@/api/goods/multiUnit").default,
      sApi: require("@/api/goods/goods").default,
      api: require("@/api/sale/stInDoc").default,
      saleApi: require("@/api/sale/sales").default,
      account_api: require("@/api/goods/goods").default,
      ggApi: require("@/api/oper/groupGoods").default,
      trApi: require("@/api/ba/tradeUnitReport").default,
      PriAdjustGoodsList: [],
      DAccount: [],
      initDAccount: [],
      initTotal: 0,
      Goods: [],
      GoodsId: '',
      goodInfo: null, //选择商品后返回的信息
    };
  },
  mounted() {
    this.account_api
      .list({ Status: 1, pageIndex: 1, pageSize: 7 })
      .then((res) => {
        if (res.Code == 0)
          (this.DAccount = res.Data),
            (this.initDAccount = res.Data),
            (this.initTotal = res.Count);
      });

    
  },
  
  methods: {

    //设置预购单明细
    setDetail(data){
      this.tableData = [];
      data.forEach((v) => {
        let goods = {
            T: 0,
            OrderGoodsId: 0,
            OrderId: 0,
            BarCode: v.BarCode,
            GoodsName: v.GoodsName,
            GoodsId: v.GoodsId,
            Model: v.Model,
            UnitName: "",
            Quantity: v.Quantity,
            Quantity1: 0,
            Quantity2: 0,
            BatchNo: "",
            Offer: v.Offer || 0,
            Discount: 100,
            Price: v.Price,
            NoTaxPrice: 0,
            ExistQuantity: 0,
            AvailableQuantity: 0,
            TaxRate: 0,
            TaxAmount: 0,
            Amount: v.Amount || 0,
            NoTaxPrice: 0,
            NoTaxAmount: v.NoTaxAmount || 0,
            PromotionType: 0,
            PromotionId: 0,
            ReferenceCost: v.ReferenceCost || 0,
            GrossProfit: 0,
            Remark: v.Remark || '',
            Thumbnail: "",
            OutQuantity: 0,
            AddTime: v.AddTime,
            WholesalePrice: v.WholesalePrice,
            UnitId: "",
            UnitId1: "",
            UnitId2: "",
            SupplierName: v.SupplierName || "",
            SupplierId: v.SupplierId,
          };

          if(v.Units.length > 0){
            goods.UnitName = v.Units[0].UnitName;
            goods.UnitId = v.Units[0].UnitId;
          }

          this.tableData.push(goods)
          console.log('this.tableData============', this.tableData)
      })
       
    },

    //弹出商品列表弹窗
    add(){
      this.ggApi.list({ GroupId: 0 }).then((res) => {
        this.Goods = res.Data;
        let ids = this.Goods.map((x) => x.GoodsId);
        return ids;
      }).then(ids => {
        this.$refs.goodsDialog.open().then((that) => {
          console.log(that)
          that.getTree();
          that.getData({ Status: 1, NotIds: ids, PromotionType: 0 });
        });
      })
      
      
    },
  

    // 选择商品
    selectGood(data){
      this.$refs.dialog.open();
      this.goodInfo = data;
      console.log('goodInfo============', this.goodInfo)
      this.GoodsId = data.GoodsId;
    },

    // 填写价格保存,获取接口返回数据
    save(data){
      console.log('data======', data)
      console.log(this.trApi)
      this.trApi.getCoodsReported(this.GoodsId, data).then(res => {
        res.Data.forEach((v) => {

          let goods = {
            T: 0,
            OrderGoodsId: 0,
            OrderId: 0,
            BarCode: this.goodInfo.BarCode,
            GoodsName: v.GoodsName,
            GoodsId: v.GoodsId,
            Model: this.goodInfo.Model,
            UnitId: 0,
            // UnitName: "",
            Quantity: v.Quantity,
            Quantity1: 0,
            Quantity2: 0,
            BatchNo: "",
            Offer: 0,
            Discount: 100,
            Price: v.Price,
            NoTaxPrice: 0,
            ExistQuantity: 0,
            AvailableQuantity: 0,
            TaxRate: 0,
            TaxAmount: 0,
            Amount: 0,
            NoTaxPrice: 0,
            NoTaxAmount: 0,
            PromotionType: 0,
            PromotionId: 0,
            ReferenceCost: this.goodInfo.ReferenceCost,
            GrossProfit: 0,
            Remark: this.goodInfo.Remark,
            Thumbnail: "",
            OutQuantity: 0,
            AddTime: v.AddTime,
            WholesalePrice: this.goodInfo.WholesalePrice,
            UnitId: "",
            UnitId1: "",
            UnitId2: "",
            SupplierName: v.TradeUnitName,
            SupplierId: v.TradeUnitId,
          };

          this.multi.list({ GoodsId: goods.GoodsId }).then((res) => {
            goods.Units = res.Data;
            res.Data.forEach((e) => {
              if (e.IsMain) {
                goods.UnitId = e.UnitId;
                goods.Rate1 = e.Rate;
              }
              if (goods.UnitId2 == e.UnitId) {
                goods.Rate2 = e.Rate;
              }
            });
          });

          this.tableData.push(goods);
        })
        this.$refs.dialog.close(true);
      })
    },
   
    // 供应商选择
    setSupplier(e, row) { 
      row.SupplierId = e.TradeUnitId;
      row.SupplierName = e.TradeUnitName;
    },
    unitChange(row, name) {
      row.Units.forEach((e) => {
        if (e.UnitId == row["UnitId" + name]) {
          row["Rate" + name] = e.Rate;
        }
      });
      this.count(row);
    },
    onBlur(row, type) {
      if (row[type] == null) row[type] = 0;
    },
    onFocus(row, type) {
      if (row[type] == 0) row[type] = null;
    },
    resetFun() {
      this.pageParams.pageIndex = 1;
      this.DAccount = this.initDAccount;
      this.listTotal = this.initTotal;
    },
    currentPage(val, row) {
      this.pageParams.pageIndex = val;
      let GoodsName = row.GoodsName;
      this.account_api
        .list({ Status: 1, pageIndex: val, pageSize: 7, GoodsName })
        .then((res) => {
          if (res.Code == 0) {
            this.DAccount = res.Data;

            this.listTotal = res.Count;
          }
        });
    },
    inputText(text, row) {
      row.GoodsName = text;
      this.account_api
        .list({ Status: 1, pageIndex: 1, pageSize: 7, GoodsName: text })
        .then((res) => {
          if (res.Code == 0) {
            this.DAccount = res.Data;

            this.listTotal = res.Count;
          }
        });
    },
    getSummaries(param) {
      console.log('param==================', param)
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        if (index === 10 || index === 11 || index === 12 || index === 13) {
          const values = data.map((item) => {
            // console.log(`item-${index}`, item, column.property, item[column.property])
            return Number(item[column.property])
          });
          // console.log(`data-${index}`, values)
          // console.log('index====================',column, index)
          if (!values.every((value) => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return Math.floor((prev + curr) * 100) / 100;
              } else {
                return Math.floor(prev * 100) / 100;
              }
            }, 0);
            // console.log(`sums-${index}================`, sums[index])
            if (index != 10) {
              sums[index] = this.$commonJs.getThousandNum(sums[index]);
            } else {
              sums[index] = sums[index];
            }
          }
          return;
        }
      });
      console.log('sum=========================', sums)
      return sums;
    },
    rowClick(row) {
      if (!this.readonly) {
        var index = this.$refs.list.data.indexOf(row);
        if (index + 1 == this.$refs.list.data.length) {
          //
          this.addGoods();
        }
      }
    },
    onSelect(e, row) {
      row.T = row.T == 0 ? 0 : 1;
      row.OrderGoodsId = 0;
      row.OrderId = this.info.OrderId || 0;
      row.BarCode = e.BarCode;
      row.GoodsName = e.GoodsName;
      row.GoodsId = e.GoodsId;
      row.Model = e.Model || "";
      row.UnitId = e.UnitId || 0;
      // row.UnitName = e.MainUnitName || "";
      row.Quantity = 0;
      row.BatchNo = e.BatchNo || "";
      row.Offer = e.WholesalePrice || 0;
      row.Discount = 100;
      row.Price = e.WholesalePrice || 0;
      row.ExistQuantity = e.ExistQuantity || 0;
      row.AvailableQuantity = e.AvailableQuantity || 0;
      row.TaxRate = 0;
      row.TaxAmount = 0;
      row.Amount = 0;
      row.NoTaxPrice;
      row.NoTaxAmount = 0;
      row.PromotionType = 0;
      row.PromotionId = 0;
      row.ReferenceCost = e.ReferenceCost || 0;
      row.GrossProfit = 0;
      row.Remark = e.Remark || "";
      row.Thumbnail = "";
      row.OutQuantity = 0;
      row.AddTime = this.info.DocDate || today;
      this.multi.list({ GoodsId: e.GoodsId }).then((res) => {
        row.Units = res.Data;
        res.Data.forEach((e) => {
          if (e.IsMain) {
            row.UnitId = e.UnitId;
            row.Rate1 = e.Rate;
          }
          if (row.UnitId2 == e.UnitId) {
            row.Rate2 = e.Rate;
          }
        });
      });
    },
    getData() {
      this.tableData = [];
      this.info.Goods.forEach((e) => {
        if (e.UnitId == 0) {
          e.UnitId = null;
        }
        if (e.UnitId1 == 0) {
          e.UnitId1 = null;
        }
        if (e.UnitId2 == 0) {
          e.UnitId2 = null;
        }
        e.T = null;
        e.Units.forEach((v) => {
          if (e.UnitId1 == v.UnitId) {
            e.Rate1 = v.Rate;
          }
          if (e.UnitId2 == v.UnitId) {
            e.Rate2 = v.Rate;
          }
        });
      });
      console.log('getData============', this.tableData)
      this.tableData = this.info.Goods;
      // this.saleApi.getGoodsList(this.info.OrderId).then((res) => {
      //   this.tableData = res.Data;
      // });
    },
    del(row, index) {
      this.$confirm("确认删除该行数据吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        if (row.T !== 0) {
          row.T = 2;
          this.tableDel.push(row);
        }
        if (this.tableData.length == 1) {
          this.tableData.splice(index, 1);
          this.addGoods();
        } else {
          this.tableData.splice(index, 1);
        }
        this.subTable();
      });
    },
    copy(row, index) {
      this.tableData.splice(index, 0, { ...row });
      this.tableData[index].OrderGoodsId = 0;
      this.tableData[index].T = 0;
      this.subTable();
    },
    addGoods() {
      let goods = {
        T: 0,
        OrderGoodsId: 0,
        OrderId: 0,
        BarCode: "",
        GoodsName: "",
        GoodsId: "",
        Model: "",
        UnitId: 0,
        // UnitName: "",
        Quantity: 0,
        Quantity1: 0,
        Quantity2: 0,
        BatchNo: "",
        Offer: 0,
        Discount: 100,
        Price: 0,
        NoTaxPrice: 0,
        ExistQuantity: 0,
        AvailableQuantity: 0,
        TaxRate: 0,
        TaxAmount: 0,
        Amount: 0,
        NoTaxPrice: 0,
        NoTaxAmount: 0,
        PromotionType: 0,
        PromotionId: 0,
        ReferenceCost: 0,
        GrossProfit: 0,
        Remark: "",
        Thumbnail: "",
        OutQuantity: 0,
        AddTime: "",
        WholesalePrice: "",
        UnitId: "",
        UnitId1: "",
        UnitId2: "",
        SupplierName: '',
        SupplierId: '',
      };
      this.tableData.push(goods);
 
    },
    setGoods(e) {
      console.log("e===============", JSON.parse(JSON.stringify(e)));
      let date = new Date();
      let today = this.$commonJs.getToday();
      var params = { GoodsIds: [e.GoodsId], AdjustDate: this.info.DocDate };
      this.sApi.getGoodsPrice(params).then((res) => {
        let goods = {
          T: 0,
          OrderGoodsId: 0,
          OrderId: this.info.OrderId || 0,
          BarCode: e.BarCode,
          GoodsName: e.GoodsName,
          GoodsId: e.GoodsId,
          Model: e.Model || "",
          UnitId: e.UnitId,
          UnitId1: e.UnitId1,
          UnitId2: e.UnitId2,
          Rate1: 0,
          Rate2: 0,
          // UnitName: e.MainUnitName || "",
          Quantity: e.Quantity,
          Quantity1: e.Quantity,
          Quantity2: null,
          BatchNo: e.BatchNo || "",
          Offer: e.WholesalePrice || 0,
          Discount: 100,
          Price: e.WholesalePrice || 0,
          NoTaxPrice: e.WholesalePrice || 0,
          ExistQuantity: e.ExistQuantity || 0,
          AvailableQuantity: e.AvailableQuantity || 0,
          TaxRate: 0,
          TaxAmount: 0,
          Amount: e.Amount || 0,
          NoTaxAmount: e.NoTaxAmount || 0,
          PromotionType: 0,
          PromotionId: 0,
          ReferenceCost: e.ReferenceCost || 0,
          GrossProfit: 0,
          Remark: e.Remark || "",
          Thumbnail: "",
          OutQuantity: 0,
          AddTime: this.info.DocDate || today,
          WholesalePrice: e.WholesalePrice,
          Units: [],
        };
        this.multi.list({ GoodsId: e.GoodsId }).then((res) => {
          goods.Units = res.Data;
          res.Data.forEach((x) => {
            if (x.IsMain) {
              goods.UnitId = x.UnitId;
              goods.UnitId1 = x.UnitId;
              goods.Rate1 = x.Rate;
            }
            if (goods.UnitId2 == x.UnitId) {
              goods.Rate2 = x.Rate;
            }
          });
        });
     
        this.tableData.push(goods);
        this.subTable();
      });
    },
    changeNum(row) {
      console.log('row===========', row.Quantity, typeof row.Quantity)
      row.Quantity = Math.floor(row.Quantity);
      // this.count(row);
    },
    rateChange(row) {
      this.count(row);
    },
    disChange(row) {
      this.count(row);
    },
    count(row) {
      let price = row.Price ? Number(row.Price) : 0;
      let dis = row.Discount > 0 ? Number(row.Discount) : 100;
      let qua = row.Quantity ? Number(row.Quantity) : 0;
      
      let rate = row.TaxRate ? Number(row.TaxRate) : 0;
      let ref = row.ReferenceCost ? Number(row.ReferenceCost) : 0;
      if (row.T !== 0) {
        row.T = 1;
      }
      if (this.disposeTax == 1) {
        row.Price = dis
          ? (row.Offer * (dis / 100) * (1 + rate / 100)).toFixed(2)
          : (row.Offer * (1 + rate / 100)).toFixed(2);
      } else {
        row.Price = dis
          ? (row.Offer * (dis / 100) * (1 + rate / 100)).toFixed(2)
          : (row.Offer * (1 + rate / 100)).toFixed(2);
      }

      row.Amount = ((row.Price * qua * 100) / 100).toFixed(2);
      row.NoTaxAmount = (row.Offer * (dis / 100) * row.Quantity).toFixed(2);
      row.NoTaxPrice = dis ? (row.Offer * (dis / 100)).toFixed(2) : row.Offer;
      row.TaxAmount =
        ((qua * ((row.NoTaxPrice * (rate * 10)) / 1000) * 100) / 100).toFixed(
          2
        ) || 0;
      row.Quantity = (1 / row.Rate1) * qua;
      console.log("🚀 ~ count ~ row.Rate1:", row.Rate1)
      console.log("🚀 ~ count ~ qua:", qua)
      console.log("🚀 ~ count ~ row.Quantity:", row.Quantity)
    
      // row.GrossProfit = row.Amount - (qua * ref)
      this.subTable();
    },
    subTable() {
      this.$emit("getList", this.tableData.concat(this.tableDel));
    },
  },
};
</script>

<style>
.el-link {
  font-size: 14px;
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}

input[type="number"] {
  -moz-appearance: textfield;
}
.btn_box{
  display: flex;
  justify-content: flex-end;
  margin: 8px 0;
}
</style>
